import apiConfig from "constants/apiConfig";
import { Influencer, MediaProductType } from "types/influencer";
// import { InfluencerInsights, Posts } from "types/influencer";
import axiosClient from "utils/axiosClient";

// export const fetchInfluencerInsights = async (agencyId: string, influencerId: string): Promise<InfluencerInsights> => {
//     const response = await axiosClient.get(apiConfig.FETCH_INFLUENCER_INSIGHTS.url.replace('<agencyId>', agencyId)
//         .replace('<influencerId>', influencerId)
//     )
//     return response.data;
// }

export const fetchPost = async (hubId: string, influencerId: string, postId: string) => {
    const response = await axiosClient.get(apiConfig.FETCH_INFLUENCER_POST.url.replace('<hubId>', hubId)
        .replace('<influencerId>', influencerId)
        .replace('<postId>', postId)
    )
    return response.data.post;
}

export const fetchBasicPost = async (postId: string) => {
    const response = await axiosClient.get(apiConfig.FETCH_BASIC_POST.url.replace('<postId>', postId))
    return response.data.post;
}

// export const fetchMedia = async (agencyId: string, influencerId: string, payload: any = {}) : Promise<Posts> => {
//     const response = await axiosClient.get(apiConfig.FETCH_INFLUENCER_MEDIA.url.replace('<agencyId>', agencyId)
//     .replace('<influencerId>', influencerId), {params: {...payload, limit: 15, sort: 'like_count' }});

//     return response.data;
// }


export const fetchBasicSocialPost = async (hubId: string, postId: string) => {
    const response = await axiosClient.get(apiConfig.FETCH_BASIC_SOCIAL_POST.url
        .replace('<hubId>', hubId)
        .replace('<postId>', postId)
    )
    return response.data.social_post;
}

export const fetchSocialPost = async (hubId: string, socialAccountId: string, socialPostId: string) => {
    const response = await axiosClient.get(apiConfig.FETCH_SOCIAL_POST.url
        .replace('<hubId>', hubId)
        .replace('<socialAccountId>', socialAccountId)
        .replace('<socialPostId>', socialPostId)
    )
    return response.data.social_post;
}


export const fetchSocialPosts = async (hubId: string, socialAccountId: string, type: MediaProductType, page: number)  => {
    const response = await axiosClient.get(apiConfig.FETCH_SOCIAL_POSTS.url.replace('<hubId>', hubId).replace('<socialAccountId>', socialAccountId), { params: { type, page, sort: 'timestamp_tz' } });
    return response.data;
}


export const fetchInfluencer = async (hubId: string, influencerId: string): Promise<Influencer> => {
    const response = await axiosClient.get(apiConfig.FETCH_INFLUENCER.url.replace('<hubId>', hubId).replace('<influencerId>', influencerId))
    return response.data?.influencer;
}

export const updateInfluencer = async (hubId: string, influencerId: string, payload: Partial<Influencer>): Promise<Influencer> => {
    const response = await axiosClient.put(apiConfig.UPDATE_INFLUENCER.url.replace('<hubId>', hubId).replace('<influencerId>', influencerId), payload)
    return response.data?.influencer;
}

export const fetchCities = async (q: string = ''): Promise<string[]> => {
    const response = await axiosClient.get(apiConfig.FETCH_CITIES.url, { params: { q } })
    return response.data.results as string[];
}

export const fetchLatestInfluencerSocialMedia = async (hubId: string, socialAccountId: string, entity_id?: string) => {
    const response = await axiosClient.post(apiConfig.FETCH_LATEST_SOCIAL_MEDIA.url.replace('<hubId>', hubId).replace('<socialAccountId>', socialAccountId), {...(entity_id ? {entity_id} : {})});
    return response.data;
}